
const getFieldParsleyErrorContainer = fieldId => $('[class*=__' + fieldId + '-error]');
const showErrorSummary = () =>
    $('.errors-summary--hidden').removeClass('errors-summary--hidden');

const hideEmptySummary = () =>
    $('.errors-summary').toggleClass('errors-summary--hidden', $('.errors-summary li').length === 0)

const showErrorMessage = (fieldId, message) =>
    getFieldParsleyErrorContainer(fieldId)
        .html(message)
        .removeClass('errors__field-error-message--hidden')
        .addClass('errors__field-error-message');

const hideErrorMessage = (fieldId, message) =>
    getFieldParsleyErrorContainer(fieldId)
        .html(message)
        .addClass('errors__field-error-message--hidden')
        .removeClass('errors__field-error-message');

const formatErrorMessage = (message) => {
    if (message[message.length - 1] === ".") {
        message = message.slice(0, -1);
    }

    return message[0].toLowerCase() + message.substring(1);
};

const buildErrorListItem = (fieldId, formattedMessage) =>
    `<li class="errors-summary__list-item" data-related-field="${fieldId}">
        <a class="errors-summary__link--js-anchor-${fieldId}" href="#${fieldId}">
            ${formattedMessage}
        </a>
     </li>`

class ParsleyEventsView {
    showFieldErrors(messages, element, fieldId) {

        $('.errors-summary__list')
            .find(`li[data-related-field="${fieldId}"]`)
            .remove()

        const message = messages[messages.length - 1]
        let formattedMessage = formatErrorMessage(message);

        $('.errors-summary__list')
            .append(buildErrorListItem(fieldId, formattedMessage));

        showErrorSummary()
        showErrorMessage(fieldId, message);

        element.addClass('errors__field-error');
    }

    removeFieldErrors(messages, element, fieldId) {

        $('.errors-summary__list')
            .find(`li[data-related-field="${fieldId}"]`)
            .remove()

        const message = messages[messages.length - 1]

        hideErrorMessage(fieldId, message);

        hideEmptySummary();

        element.removeClass('errors__field-error');
    }

    formValidate() {
        $('.errors-summary').addClass('errors-summary--hidden');
        $('.errors-summary__list').html('');

        $('.errors__field-error-message').each((index, element) => $(element).html('').addClass('errors__field-error-message--hidden'));
        $('.errors__field-error').each((index, element) => $(element).removeClass('errors__field-error'));

        $('.errors-serverside').each((index, element) => $(element).addClass('errors-serverside--hidden'));
        $('.errors-serverside__error-message').each((index, element) => $(element).addClass('errors-serverside__error-message--hidden'));

        $('.message').each((index, element) => $(element).addClass('message--hidden'));
    }

    showErrorMessage() {
        $('.errors-summary').removeClass('errors-summary--hidden');
        $('.errors-summary__list').html('');
    }
}

module.exports = ParsleyEventsView;